import { gql, TypedDocumentNode } from '@apollo/client';

export type GetDeliveryEstimateQueryVariables = {
  countryCode?: string;
  zipCode?: string;
  currency?: string;
  stateCode?: string;
  variantId?: string;
};

export type GetDeliveryEstimateQuery = {
  deliveryEstimate: {
    __typename: 'RestDeliveryEstimate';
    charges: number;
    name: string;
    transitTime: string;
    currency: string;
    arrivalDate: string;
  };
};

export const GET_DELIVERY_ESTIMATE_QUERY: TypedDocumentNode<
  GetDeliveryEstimateQuery,
  GetDeliveryEstimateQueryVariables
> = gql`
  query GetDeliveryEstimateQuery(
    $countryCode: String
    $zipCode: String
    $currency: String
    $stateCode: String
    $variantId: String
  ) {
    deliveryEstimate(
      country_code: $countryCode
      zip_code: $zipCode
      currency: $currency
      state_code: $stateCode
      variant_id: $variantId
    )
      @rest(
        type: "RestDeliveryEstimate"
        endpoint: "moda"
        path: "/v3.5/shipments/delivery_estimate?{args}"
      ) {
      charges
      name
      transitTime: transit_time
      currency
      arrivalDate: arrival_date
    }
  }
`;
